import moment from 'moment';
import * as types from '../../constants/actionsType';
import Colors from '../../../utils/constants/Colors';

const initialState = {
  summaryCard: [],
  accNo: ''
}
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.STORE_ACCNO:
      return {
        ...state,
        accNo: action.payload,
      };
    default:
      return state
  }
}
export default reducer
